import type { ComponentMultiStyleConfig } from '@chakra-ui/theme'

const Switch: ComponentMultiStyleConfig = {
  parts: ['container', 'track', 'thumb'],
  baseStyle: {
    track: {
      _invalid: {
        _checked: {
          backgroundColor: '#F94848',
        },
      },
    },
  },
}

export default Switch
